import React, { useEffect } from "react";
import Engdesignbanner from "./Engdesignbanner";
import Engdesignabout from "./Engdesignabout";
import Engdesignfeatures from "./Engdesignfeatures";
import Engdesigncards from "./Engdesigncards";
import Webbanner from "./Webbanner";

const Engneeringdesignsolution = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
        <Engdesignbanner/>
      
      <Engdesignabout/>

      <Engdesignfeatures/>
      <Engdesigncards/>
    </div>
  );
};

export default Engneeringdesignsolution;
